module.exports = __webpack_public_path__ + "media/img/posts/post-1-0c5659986c9235028dd476590a311406.jpg";